import { ApolloError, useQuery } from '@apollo/client'
import ContractQueries from '../ContractQueries'
import { CurrentContractQuery, CurrentContractQueryVariables } from '../../../types'

export default (employeeId: number): { data: CurrentContractQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, error, loading } = useQuery<CurrentContractQuery, CurrentContractQueryVariables>(ContractQueries.CurrentContractGql, {
    variables: {
      employeeId: employeeId,
    },
  })

  return { data, error, loading }
}
